var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Comment",
    d: "M25.784,21.017a11.006,11.006,0,1,0-4.766,4.768l4.74,1.185a1,1,0,0,0,1.212-1.213Zm-2.033.11.874,3.5-3.5-.875a1.006,1.006,0,0,0-.731.1A9.011,9.011,0,1,1,23.849,20.4,1,1,0,0,0,23.751,21.127Z",
    transform: "translate(-5 -5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.50862af3282d8634a86ca4cc9daf7842.svg";
export { ForwardRef as ReactComponent };